module.exports = __webpack_public_path__ + "img/invoice.82285a5a.png";